// extracted by mini-css-extract-plugin
module.exports = {"containerIP":"_2xdPrcrH4mLM299vpGr7jK","messageInfos":"_10XSMPzK6RhOGIVuhz8vNJ","infoLabel":"ZjEoRCY-rSdZzB7qtMxku"};